module.exports = __webpack_public_path__ + "static/media/NFT.2cf74a95.png";